// King product gallery: pause autoplay during interaction, resume after (keeps seamless loop)
// + forces manual swipe to be available immediately on mobile
(function () {
  const selectors = [
    '.dual-media-slideshow .swiper',
    '.product__media .swiper',
    '.product__media-list .swiper',
    '[data-product-media] .swiper',
    '.swiper'
  ];

  const RESUME_AFTER_MS = 900; // 600–1200 feels best

  function findSliders() {
    const nodes = [];
    selectors.forEach(sel => document.querySelectorAll(sel).forEach(n => nodes.push(n)));
    return [...new Set(nodes)];
  }

  function getSwiper(el) {
    return el && el.swiper ? el.swiper : null;
  }

  function tuneAutoplay(sw) {
    // Prevent "stop at end" behavior after interaction
    if (sw?.params?.autoplay) {
      sw.params.autoplay.disableOnInteraction = false;
      sw.params.autoplay.stopOnLastSlide = false;
    }
  }

  function forceEarlyTouch(sw) {
    // Some themes delay enabling touch until media finishes loading.
    // Force touch to be available as soon as Swiper exists.
    if (!sw || sw.__kkTouchForced) return;
    sw.__kkTouchForced = true;

    try {
      sw.allowTouchMove = true;

      if (sw.params) {
        sw.params.allowTouchMove = true;
        sw.params.simulateTouch = true;
      }

      sw.update && sw.update();
    } catch (e) {}
  }

  function stop(sw) {
    try { sw?.autoplay?.stop?.(); } catch (e) {}
  }

  function start(sw) {
    try { sw?.autoplay?.start?.(); } catch (e) {}
  }

  function bindOne(el) {
    if (!el || el.__kkBound) return;
    el.__kkBound = true;

    const sw = getSwiper(el);
    if (!sw) return;

    // ✅ new: unlock swipe ASAP (no change to other functionality)
    forceEarlyTouch(sw);

    // keep existing behavior
    tuneAutoplay(sw);

    let resumeTimer = null;
    let interacting = false;

    const pauseNow = () => {
      interacting = true;
      tuneAutoplay(sw);
      stop(sw);
      if (resumeTimer) clearTimeout(resumeTimer);
    };

    const resumeSoon = () => {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        interacting = false;
        forceEarlyTouch(sw);
        tuneAutoplay(sw);
        start(sw);
      }, RESUME_AFTER_MS);
    };

    // Pause only on "start" events (keeps loop seamless, avoids move-event jank)
    el.addEventListener('touchstart', pauseNow, { passive: true });
    el.addEventListener('pointerdown', pauseNow, { passive: true });
    el.addEventListener('mousedown', pauseNow, { passive: true });

    // Resume after interaction ends
    el.addEventListener('touchend', resumeSoon, { passive: true });
    el.addEventListener('touchcancel', resumeSoon, { passive: true });
    el.addEventListener('pointerup', resumeSoon, { passive: true });
    el.addEventListener('mouseup', resumeSoon, { passive: true });

    // Trackpad / wheel: pause briefly, then resume
    el.addEventListener('wheel', () => {
      pauseNow();
      resumeSoon();
    }, { passive: true });

    // Safety: if Swiper emits edge states after interaction, keep autoplay alive
    if (sw.on) {
      sw.on('reachEnd', () => {
        if (interacting) return;
        forceEarlyTouch(sw);
        tuneAutoplay(sw);
        start(sw);
      });
      sw.on('fromEdge', () => {
        if (interacting) return;
        forceEarlyTouch(sw);
        tuneAutoplay(sw);
        start(sw);
      });
    }
  }

  function bind() {
    findSliders().forEach(bindOne);
  }

  // King sometimes initializes Swiper after DOMContentLoaded.
  // Retry a few times to catch late init (improves "swipe available immediately").
  function bindWithRetries() {
    let tries = 0;
    const maxTries = 8;
    const timer = setInterval(() => {
      tries += 1;
      bind();
      if (tries >= maxTries) clearInterval(timer);
    }, 250);
  }

  // custom.js is deferred — DOMContentLoaded may have already fired
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindWithRetries);
  } else {
    bindWithRetries();
  }
  document.addEventListener('shopify:section:load', bindWithRetries);
})();



// ═══════════════════════════════════════════════════════════════════════════
// MOBILE MENU TOGGLE — Kitty Kabana
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  function initMobileMenuToggle() {
    var drawer  = document.querySelector('[data-drawer="mobile-menu-drawer"]');
    var toggler = document.querySelector('[data-mobile-toggler]');
    if (!drawer || !toggler) return;
    if (toggler.__kkMobInit) return; // guard: never double-bind
    toggler.__kkMobInit = true;

    // 1. Watch 'show' class → sync body class for CSS arrow + header state
    var classObserver = new MutationObserver(function () {
      if (drawer.classList.contains('show')) {
        document.body.classList.add('mob-menu-open');
      } else {
        document.body.classList.remove('mob-menu-open');
      }
    });
    classObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // 2. FIX OPEN DELAY: theme sets display:flex immediately but adds 'show'
    //    (which triggers the CSS slide transition) only after a 400ms timeout.
    //    We watch the style attribute — the instant display:flex is set, we add
    //    'show' ourselves so the animation starts immediately with zero delay.
    var styleObserver = new MutationObserver(function () {
      if (drawer.style.display === 'flex' && !drawer.classList.contains('show')) {
        drawer.classList.add('show');
        document.body.classList.add('overflow-hidden');
      }
    });
    styleObserver.observe(drawer, { attributes: true, attributeFilter: ['style'] });

    // 3. Capture-phase click: if open, close and block theme re-opening it.
    //    capture=true fires BEFORE the theme's bubble-phase listener.
    //    stopImmediatePropagation() prevents the race that caused freezing.
    toggler.addEventListener('click', function (e) {
      if (!drawer.classList.contains('show')) return; // let theme open it

      e.stopImmediatePropagation(); // block theme's toggleMobileMenu()

      drawer.classList.remove('show', 'shadow');
      document.body.classList.remove('overflow-hidden');

      setTimeout(function () {
        drawer.style.display = 'none';
        drawer.querySelectorAll('[data-menu-item].active').forEach(function (el) {
          el.classList.remove('active');
        });
        drawer.querySelectorAll('[data-mobile-item].animate').forEach(function (el) {
          el.classList.remove('animate');
        });
      }, 360);

    }, true); // ← capture phase
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuToggle);
  } else {
    initMobileMenuToggle();
  }
  document.addEventListener('shopify:section:load', initMobileMenuToggle);
})();
// ── End of mobile menu toggle ─────────────────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// FILTER / SORT AJAX — re-initialize card animation after grid swap
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  function hookFilterAjax() {
    var gridBox = document.querySelector('[data-collections-grid]');
    if (!gridBox || gridBox.__kkHook) return;
    gridBox.__kkHook = true;
    // [data-collections-grid].innerHTML is replaced by FilterForm.renderProductGrid().
    // The old [main-collection-products] element (which kkSetupObserver observed)
    // is destroyed. Watch for childList changes to catch the replacement, then
    // re-run kkSetupObserver on the new element so cards animate in correctly.
    new MutationObserver(function () {
      requestAnimationFrame(function () {
        if (typeof window.__kkSetupObserver === 'function') window.__kkSetupObserver();
        if (typeof window.__fcg2_boot === 'function') window.__fcg2_boot();
      });
    }).observe(gridBox, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookFilterAjax);
  } else {
    hookFilterAjax();
  }
  document.addEventListener('shopify:section:load', hookFilterAjax);
})();
// ── End of filter/sort AJAX hook ──────────────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// MOBILE FILTER AUTO-CLOSE — dismiss panel immediately on selection
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  // [data-filters-sidebar] persists across AJAX (only its innerHTML is swapped),
  // so one delegated listener handles all current and future checkboxes/radios.
  function initMobileFilterClose() {
    var sidebar = document.querySelector('[data-filters-sidebar]');
    if (!sidebar || sidebar.__kkAutoClose) return;
    sidebar.__kkAutoClose = true;

    sidebar.addEventListener('change', function (e) {
      if (window.innerWidth >= 768) return;
      if (!e.target.matches('input[type="checkbox"], input[type="radio"]')) return;
      sidebar.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileFilterClose);
  } else {
    initMobileFilterClose();
  }
  document.addEventListener('shopify:section:load', initMobileFilterClose);
})();
// ── End of mobile filter auto-close ───────────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// "No reviews yet" — empty state + review drawer for Vitals section
// ═══════════════════════════════════════════════════════════════════════════
(function () {

  // ── Drawer open / close ───────────────────────────────────────────────────
  var drawerEl  = null;
  var ratingVal = 0;

  function getDrawer() {
    return document.getElementById('kk-review-drawer');
  }

  function openDrawer() {
    drawerEl = getDrawer();
    if (!drawerEl) return;

    // Populate product image from the page
    var imgWrap   = document.getElementById('kk-review-product-img-wrap');
    var pageSrc   = getProductImageSrc();
    if (imgWrap && pageSrc && !imgWrap.querySelector('img')) {
      var thumb = document.createElement('img');
      thumb.src     = pageSrc;
      thumb.alt     = '';
      thumb.loading = 'lazy';
      imgWrap.appendChild(thumb);
    }

    drawerEl.classList.add('is-open');
    drawerEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var closeBtn = document.getElementById('kk-review-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawerEl = getDrawer();
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function getProductImageSrc() {
    // Try variant/featured media first, then fall back to first product image on page
    var candidates = [
      '.product--media img',
      '.product-media-container img',
      '.product__media img',
      '[data-media-id] img',
      '.swiper-slide-active .media img',
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.src && el.src.indexOf('data:') !== 0) return el.src;
    }
    return null;
  }

  // ── Star rating interaction ───────────────────────────────────────────────
  function initStars() {
    drawerEl = getDrawer();
    if (!drawerEl) return;
    var stars = drawerEl.querySelectorAll('.kk-review-star');

    stars.forEach(function (star) {
      star.addEventListener('mouseenter', function () {
        var val = parseInt(star.dataset.value, 10);
        stars.forEach(function (s) {
          var v = parseInt(s.dataset.value, 10);
          s.classList.toggle('is-hovered', v <= val);
          if (ratingVal === 0) s.classList.remove('is-selected');
        });
      });

      star.addEventListener('mouseleave', function () {
        stars.forEach(function (s) {
          s.classList.remove('is-hovered');
          var v = parseInt(s.dataset.value, 10);
          s.classList.toggle('is-selected', v <= ratingVal);
        });
      });

      star.addEventListener('click', function () {
        ratingVal = parseInt(star.dataset.value, 10);
        var ratingInput = document.getElementById('kk-rating-input');
        if (ratingInput) ratingInput.value = ratingVal;
        stars.forEach(function (s) {
          var v = parseInt(s.dataset.value, 10);
          s.classList.toggle('is-selected', v <= ratingVal);
        });
        var err = document.getElementById('kk-stars-error');
        if (err) err.hidden = true;
      });
    });
  }

  // ── Photo upload previews ─────────────────────────────────────────────────
  function initPhotoUpload() {
    var input    = document.getElementById('kk-review-photos');
    var previews = document.getElementById('kk-photo-previews');
    if (!input || !previews) return;

    input.addEventListener('change', function () {
      previews.innerHTML = '';
      Array.from(input.files).forEach(function (file) {
        if (file.type.indexOf('image') === 0) {
          var reader = new FileReader();
          reader.onload = function (e) {
            var img = document.createElement('img');
            img.src       = e.target.result;
            img.className = 'kk-review-form__preview-thumb';
            img.alt       = file.name;
            previews.appendChild(img);
          };
          reader.readAsDataURL(file);
        } else {
          var box = document.createElement('div');
          box.className   = 'kk-review-form__preview-file';
          box.textContent = file.name;
          previews.appendChild(box);
        }
      });
    });
  }

  // ── Form submission ───────────────────────────────────────────────────────
  function initForm() {
    var form = document.getElementById('kk-review-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Clear previous error state
      hideError();
      var starsErr = document.getElementById('kk-stars-error');
      if (starsErr) starsErr.hidden = true;

      // Validate all required fields, collect missing ones
      var missing = [];
      var nameVal  = (form.querySelector('[name="contact[name]"]')  || {}).value || '';
      var emailVal = (form.querySelector('[name="contact[email]"]') || {}).value || '';
      var bodyVal  = (document.getElementById('kk-review-body')     || {}).value || '';

      if (ratingVal === 0)       missing.push('a star rating');
      if (!nameVal.trim())       missing.push('your name');
      if (!emailVal.trim())      missing.push('your email address');
      else if (!/\S+@\S+\.\S+/.test(emailVal)) missing.push('a valid email address');
      if (!bodyVal.trim())       missing.push('a review description');

      if (missing.length) {
        showValidationError('Please provide: ' + missing.join(', ') + '.');
        return;
      }

      var submitBtn  = document.getElementById('kk-review-submit');
      var submitText = submitBtn && submitBtn.querySelector('.kk-review-form__submit-text');
      var spinner    = submitBtn && submitBtn.querySelector('.kk-review-form__submit-spinner');

      if (submitBtn)  submitBtn.disabled = true;
      if (submitText) submitText.hidden  = true;
      if (spinner)    spinner.hidden     = false;

      // Build formatted email body
      var stars       = ['', '★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★'];
      var productName = (document.getElementById('kk-review-title') || {}).textContent || '';
      var photoInput  = document.getElementById('kk-review-photos');
      var photoNames  = photoInput && photoInput.files.length
        ? Array.from(photoInput.files).map(function (f) { return f.name; }).join(', ')
        : 'None';
      var productUrl  = (form.querySelector('[name="kk_product_url"]') || {}).value || '';

      var body = [
        '⭐ NEW PRODUCT REVIEW',
        '',
        'Product: ' + productName,
        'Rating:  ' + stars[ratingVal] + ' (' + ratingVal + '/5)',
        '',
        'Review:',
        bodyVal,
        '',
        'Photos: ' + photoNames,
        '',
        'Product URL: ' + productUrl,
      ].join('\n');

      var formData = new FormData(form);
      formData.set('contact[body]', body);

      fetch('/contact', {
        method:  'POST',
        body:    formData,
        headers: { 'Accept': 'text/html,application/xhtml+xml' },
      })
        .then(function (resp) {
          if (resp.ok) {
            showSuccess();
          } else {
            showValidationError('Something went wrong. Please try again or email us directly.');
          }
        })
        .catch(function () {
          showValidationError('Something went wrong. Please try again or email us directly.');
        })
        .finally(function () {
          if (submitBtn)  submitBtn.disabled = false;
          if (submitText) submitText.hidden  = false;
          if (spinner)    spinner.hidden     = true;
        });
    });
  }

  function showSuccess() {
    var form    = document.getElementById('kk-review-form');
    var success = document.getElementById('kk-review-success');
    var product = document.getElementById('kk-review-product-row');
    if (form)    form.hidden    = true;
    if (product) product.hidden = true;
    if (success) success.hidden = false;
  }

  function showValidationError(message) {
    var errEl   = document.getElementById('kk-review-error');
    if (!errEl) return;
    var heading = errEl.querySelector('.kk-review-message__heading');
    if (heading) heading.textContent = message;
    errEl.hidden = false;
    errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideError() {
    var errEl = document.getElementById('kk-review-error');
    if (errEl) errEl.hidden = true;
  }

  // ── Close listeners ───────────────────────────────────────────────────────
  function initCloseListeners() {
    document.addEventListener('click', function (e) {
      var closeBtn = document.getElementById('kk-review-close');
      var backdrop = document.getElementById('kk-review-backdrop');
      if (e.target === closeBtn || closeBtn && closeBtn.contains(e.target)) closeDrawer();
      if (e.target === backdrop) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // ── Review detection ─────────────────────────────────────────────────────
  // Check for actual review ITEMS inside Vitals, not just an empty container
  function hasReviewContent(widget) {
    return !!(
      widget.querySelector('.vtl-pr-review-card') ||
      widget.querySelector('.vtl-pr-reviews-list > li') ||
      widget.querySelector('.vtl-pr-reviews-list > div') ||
      widget.querySelectorAll('[class*="vtl-pr-review-"]').length > 0
    );
  }

  // ── "Write a Review" button under the ratings summary (products with reviews)
  function addWriteReviewTopBtn(widget) {
    if (widget.__kkWrTop) return;
    // Insert after the ratings totals block
    var anchor = widget.querySelector('.vtl-pr-totals') ||
                 widget.querySelector('.vtl-pr-header');
    if (!anchor) return;
    widget.__kkWrTop = true;

    var btn = document.createElement('button');
    btn.className   = 'kk-write-review-top';
    btn.type        = 'button';
    btn.textContent = 'Write a Review';
    btn.addEventListener('click', function () { openDrawer(); });
    anchor.insertAdjacentElement('afterend', btn);
  }

  // ── No-reviews empty state ────────────────────────────────────────────────
  function restoreSectionSpacing(widget) {
    // Remove inline overrides so CSS defaults take back over (30px mobile, JS-set desktop)
    var appBlock = widget.closest
      ? widget.closest('[class*="product-app-block"], [class*="shopify-app-block"]')
      : null;
    if (appBlock) {
      appBlock.style.removeProperty('padding-top');
      appBlock.style.removeProperty('padding-bottom');
      appBlock.style.removeProperty('margin-top');
      appBlock.style.removeProperty('margin-bottom');
    }
    var sectionEl = document.getElementById('shopify-section-1753101594e51a8b57');
    var ancestor  = widget;
    while (ancestor && ancestor !== (sectionEl ? sectionEl.parentElement : null)) {
      ancestor.style.removeProperty('padding-top');
      ancestor.style.removeProperty('padding-bottom');
      ancestor.style.removeProperty('margin-top');
      ancestor.style.removeProperty('margin-bottom');
      if (ancestor === sectionEl) break;
      ancestor = ancestor.parentElement;
    }
  }

  function zeroNoReviewsSpacing(widget) {
    // Always re-zero spacing — runs independently of whether the DOM element exists
    var appBlock = widget.closest
      ? widget.closest('[class*="product-app-block"], [class*="shopify-app-block"]')
      : null;
    if (appBlock) {
      appBlock.style.setProperty('padding-top',    '0', 'important');
      appBlock.style.setProperty('padding-bottom', '0', 'important');
      appBlock.style.setProperty('margin-top',     '0', 'important');
      appBlock.style.setProperty('margin-bottom',  '0', 'important');
    }
    // Also walk ancestors for belt-and-braces
    var sectionEl = document.getElementById('shopify-section-1753101594e51a8b57');
    var ancestor  = widget;
    while (ancestor && ancestor !== (sectionEl ? sectionEl.parentElement : null)) {
      ancestor.style.setProperty('padding-top',    '0', 'important');
      ancestor.style.setProperty('padding-bottom', '0', 'important');
      if (ancestor === sectionEl) {
        // Desktop: CSS (min-width:769px) sets --top_spacing/--bottom_spacing on this
        // element to match Related Products / Recently Viewed; on mobile the vars
        // are unset so this collapses back to 0 — spacing there is unchanged.
        var topSpace    = getComputedStyle(sectionEl).getPropertyValue('--top_spacing').trim();
        var bottomSpace = getComputedStyle(sectionEl).getPropertyValue('--bottom_spacing').trim();
        ancestor.style.setProperty('margin-top',    topSpace    || '0', 'important');
        ancestor.style.setProperty('margin-bottom', bottomSpace || '0', 'important');
        break;
      }
      ancestor.style.setProperty('margin-top',    '0', 'important');
      ancestor.style.setProperty('margin-bottom', '0', 'important');
      ancestor = ancestor.parentElement;
    }
  }

  function addNoReviewsState(widget) {
    // Always zero spacing, even on repeat calls
    zeroNoReviewsSpacing(widget);

    if (document.querySelector('.kk-no-reviews')) return; // element already added

    var container = document.createElement('div');
    container.className = 'kk-no-reviews';

    var text = document.createElement('p');
    text.className   = 'kk-no-reviews-text';
    text.textContent = 'No reviews yet, write one now?';

    var btn = document.createElement('button');
    btn.className   = 'kk-no-reviews-btn';
    btn.type        = 'button';
    btn.textContent = 'Write a Review';
    btn.addEventListener('click', function () { openDrawer(); });

    container.appendChild(text);
    container.appendChild(btn);
    widget.appendChild(container);
  }

  // ── Desktop top-padding fix ───────────────────────────────────────────────
  // CSS !important can't always beat Vitals' own inline styles; JS wins.
  function applyDesktopPadding() {
    if (window.innerWidth < 769) return;
    var widget = document.getElementById('bundle-product_reviews');
    if (!widget) return;
    // No-reviews state manages its own spacing — don't interfere
    if (!hasReviewContent(widget)) return;
    // Walk up to find the .product-app-block ancestor and force padding
    var el = widget;
    while (el && el !== document.body) {
      if (
        el.classList.contains('product-app-block') ||
        el.classList.contains('shopify-app-block') ||
        (el.id && el.id.indexOf('shopify-section') === 0)
      ) {
        // Measure actual pixel gaps on both sides, then equalise them.
        // visualTop  = space between container's top edge and widget's top edge
        // visualBottom = space between widget's bottom edge and container's bottom edge
        // Adjust padding-top so visualTop converges to visualBottom.
        var cRect        = el.getBoundingClientRect();
        var wRect        = widget.getBoundingClientRect();
        var visualTop    = wRect.top    - cRect.top;
        var visualBottom = cRect.bottom - wRect.bottom;
        var curPadTop    = parseFloat(window.getComputedStyle(el).paddingTop) || 0;
        var newPadTop    = Math.max(10, curPadTop + (visualBottom - visualTop));
        el.style.setProperty('padding-top', newPadTop + 'px', 'important');
        break;
      }
      el = el.parentElement;
    }
    // Collapse bottom spacing on totals block so button sits closer
    var totals = widget.querySelector('.vtl-pr-totals');
    if (totals) {
      totals.style.setProperty('margin-bottom', '0', 'important');
      totals.style.setProperty('padding-bottom', '0', 'important');
    }
    // Comfortable space above the Write a Review button
    var btn = widget.querySelector('.kk-write-review-top');
    if (btn) btn.style.setProperty('margin-top', '16px', 'important');
  }

  function update() {
    var widget = document.getElementById('bundle-product_reviews');
    if (!widget) return;

    var withReviews = hasReviewContent(widget);
    var noRevEl     = document.querySelector('.kk-no-reviews');

    if (withReviews) {
      // Remove empty-state placeholder if it slipped in during early load
      if (noRevEl) {
        noRevEl.parentNode.removeChild(noRevEl);
        // Restore any padding that was zeroed for the no-reviews state
        restoreSectionSpacing(widget);
      }
      // Add top "Write a Review" button (once)
      addWriteReviewTopBtn(widget);
    } else {
      // Remove the top button if present (shouldn't normally happen)
      var topBtn = document.querySelector('.kk-write-review-top');
      if (topBtn) topBtn.parentNode.removeChild(topBtn);
      // Add empty state (once)
      addNoReviewsState(widget);
    }
  }

  // MutationObserver so we react as soon as Vitals finishes rendering —
  // faster and more reliable than guessing a fixed timeout
  function watchWidget() {
    var widget = document.getElementById('bundle-product_reviews');
    if (!widget || widget.__kkObserved) return;
    widget.__kkObserved = true;

    var debounce;
    var obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(update, 200);
    });
    obs.observe(widget, { childList: true, subtree: true });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  function boot() {
    initCloseListeners();
    initStars();
    initPhotoUpload();
    initForm();
    // Run at multiple points: MutationObserver handles the fast case,
    // timeouts are fallback for slow connections / late Vitals renders
    [800, 2000, 4000, 7000].forEach(function (delay) {
      setTimeout(function () { update(); watchWidget(); applyDesktopPadding(); }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () { update(); watchWidget(); }, 600);
    initStars();
    initPhotoUpload();
    initForm();
  });

})();
// ── End of no-reviews empty state + review drawer ─────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// BELOW-FOLD IMAGE BOOST — Kitty Kabana
// Browser default lazy-load threshold (~1250px) and lazySizes' default expand
// (370px) mean sections 4+ don't start fetching until the user is nearly there.
// This runs at DOMContentLoaded and:
//   1. Removes loading="lazy" from native-lazy images within 3 viewport heights
//      so the browser fetches them immediately in the background.
//   2. Expands lazySizes' lookahead to 1.5× viewport height and triggers a
//      synthetic scroll so it re-scans and starts fetching full-quality images
//      for all sections in that range right now, not on first scroll.
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  function boostImages() {
    var vh = window.innerHeight;
    var threshold = vh * 3;

    // Native loading="lazy" — remove attribute for images within 3vh,
    // but preserve lazy loading on inactive Swiper slides (carousel bandwidth saving)
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      try {
        if (img.closest('.swiper-slide') && !img.closest('.swiper-slide-active')) return;
        if (img.getBoundingClientRect().top < threshold) {
          img.removeAttribute('loading');
        }
      } catch (e) {}
    });

    // lazySizes — expand its lookahead and force an immediate re-scan
    if (window.lazySizes && window.lazySizes.cfg) {
      var target = Math.floor(vh * 1.5);
      if (target > (window.lazySizes.cfg.expand || 370)) {
        window.lazySizes.cfg.expand = target;
        window.dispatchEvent(new Event('scroll'));
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boostImages);
  } else {
    boostImages();
  }
  document.addEventListener('shopify:section:load', boostImages);
})();
// ── End of below-fold image boost ─────────────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// IN-APP BROWSER DETECTION — Kitty Kabana
// Instagram and Facebook IABs inject pcm.js which saturates the main thread,
// making rAF-based JS animations stutter. Flag them with kk-iab so CSS
// compositor animations take over instead.
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  if (/Instagram|FBAN|FBAV/.test(navigator.userAgent)) {
    document.documentElement.classList.add('kk-iab');
  }
})();

// ═══════════════════════════════════════════════════════════════════════════
// SLIDESHOW PARALLAX — Kitty Kabana
// CSS scroll-driven animations handle Chrome 115+ / Safari 26+.
// CSS compositor animation (@keyframes) handles Instagram/Facebook IAB.
// This JS fallback covers remaining browsers (iOS 18 Safari, Firefox, etc.).
// Uses window.scrollY + cached offsetTop — no getBoundingClientRect() in the
// hot path, so WKWebView momentum scroll stays smooth (no forced layout).
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Instagram/Facebook IAB: pure CSS compositor animation handles it
    if (document.documentElement.classList.contains('kk-iab')) return;
    // CSS scroll-driven animations (Chrome 115+, Safari 26+) run on the
    // compositor — skip the JS path on those browsers only.
    if (window.CSS && CSS.supports('animation-timeline', 'view()')) return;

    var sections = document.querySelectorAll('[data-kk-parallax]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.__kkParallaxBound) return;
      section.__kkParallaxBound = true;

      var noMobile   = section.hasAttribute('data-kk-parallax-no-mobile');
      var intensity  = (parseFloat(section.dataset.kkParallaxIntensity) || 20) / 100;
      var scale      = 1 + intensity;
      var visible    = false;
      var rafId      = null;
      var cachedEls  = null;
      var sectionTop = 0;
      var sectionH   = 0;

      function cacheLayout() {
        // Walk offsetParent chain once — cheap, no forced layout during scroll
        var el = section, top = 0;
        while (el) { top += el.offsetTop; el = el.offsetParent; }
        sectionTop = top;
        sectionH   = section.offsetHeight;
        cachedEls  = null; // slides may have changed
      }

      function getElements() {
        if (!cachedEls) {
          cachedEls = section.querySelectorAll(
            '.slideshow--item .media img, .slideshow--item .media video'
          );
        }
        return cachedEls;
      }

      function shouldSkip() {
        return noMobile && window.innerWidth < 768;
      }

      function update() {
        var scrollY      = window.scrollY || window.pageYOffset;
        var viewH        = window.innerHeight;
        var sectionMid   = sectionTop + sectionH / 2;
        // How far the section center is from the viewport center
        var visualOffset = (viewH / 2 + scrollY - sectionMid) * intensity;
        var t            = visualOffset / scale;
        var transform    = 'scale(' + scale + ') translateY(' + t + 'px)';
        getElements().forEach(function (el) { el.style.transform = transform; });
      }

      function loop() {
        if (!visible) { rafId = null; return; }
        update();
        rafId = requestAnimationFrame(loop);
      }

      function onVisibilityChange() {
        if (document.visibilityState === 'visible' && visible && !rafId) {
          rafId = requestAnimationFrame(loop);
        }
      }

      cacheLayout();
      window.addEventListener('resize', function () {
        cacheLayout();
        if (shouldSkip() && rafId) { cancelAnimationFrame(rafId); rafId = null; visible = false; }
      }, { passive: true });

      var obs = new IntersectionObserver(function (entries) {
        if (shouldSkip()) return;
        visible = entries[0].isIntersecting;
        if (visible) {
          if (!rafId) rafId = requestAnimationFrame(loop);
        } else {
          if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        }
      }, { threshold: 0 });

      if (!shouldSkip()) obs.observe(section);
      document.addEventListener('visibilitychange', onVisibilityChange);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
  document.addEventListener('shopify:section:load', initParallax);
})();
// ── End of slideshow parallax ─────────────────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// SLIDESHOW OVERLAY INSTANT-SHOW — Kitty Kabana
// iOS Safari can delay painting position:absolute overlays inside Swiper
// slides due to GPU layer compositing order. This forces every .kk-slide-overlay
// to be visible immediately by setting an explicit opacity and confirming the
// translateZ(0) GPU promotion is applied via inline style before each swipe.
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  var isIAB = document.documentElement.classList.contains('kk-iab');

  function promoteOverlays(sectionEl) {
    sectionEl.querySelectorAll('.kk-slide-overlay').forEach(function (el) {
      // Skip GPU layer promotion in Instagram/Facebook IAB — extra compositor
      // layers per slide increase memory pressure and worsen scroll performance
      if (!isIAB) {
        el.style.webkitTransform = 'translateZ(0)';
        el.style.transform      = 'translateZ(0)';
      }
      el.style.opacity = '1';
    });
  }

  function bindSection(sectionEl) {
    if (sectionEl.__kkOvBound) return;
    sectionEl.__kkOvBound = true;

    promoteOverlays(sectionEl);

    var swiperEl = sectionEl.querySelector('.swiper');
    if (!swiperEl) return;

    function tryBind() {
      var sw = swiperEl.swiper;
      if (!sw) return false;
      // In Instagram/Facebook IAB, stop autoplay — the recurring JS-driven
      // slide transitions during scroll add unnecessary main-thread work
      if (isIAB && sw.autoplay) sw.autoplay.stop();
      sw.on('sliderFirstMove',             function () { promoteOverlays(sectionEl); });
      sw.on('slideChangeTransitionStart',  function () { promoteOverlays(sectionEl); });
      return true;
    }

    if (!tryBind()) {
      var n = 0;
      var iv = setInterval(function () {
        if (tryBind() || ++n >= 40) clearInterval(iv);
      }, 100);
    }
  }

  function init() {
    document.querySelectorAll('[data-slider-wrapper]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-slider-wrapper]');
    if (s) bindSection(s);
  });
})();
// ── End of slideshow overlay instant-show ─────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// SLIDESHOW ANIM HOLD — Kitty Kabana
// Below-fold slideshows get .kk-anim-hold immediately on load, which
// suppresses [data-animate] transitions until the section is in view.
// In-viewport sections (hero) are never touched so their animation is
// unaffected. Once the IntersectionObserver fires, .kk-anim-hold is removed
// and the original CSS transition system plays the animation fresh.
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  function initSection(sectionEl) {
    if (sectionEl.__kkAnimHold) return;
    sectionEl.__kkAnimHold = true;

    var rect = sectionEl.getBoundingClientRect();
    // Section already in viewport on load (e.g. hero) — don't interfere
    if (rect.top < window.innerHeight && rect.bottom > 0) return;

    sectionEl.classList.add('kk-anim-hold');

    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      var target = entries[0].target;
      // Force-commit the held state so iOS Safari fires the CSS transition
      void target.offsetHeight;
      target.classList.remove('kk-anim-hold');
      io.disconnect();
    }, { threshold: 0.15 });

    io.observe(sectionEl);
  }

  function init() {
    document.querySelectorAll('[data-slider-wrapper]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-slider-wrapper]');
    if (s) initSection(s);
  });
})();
// ── End of slideshow anim hold ─────────────────────────────────────────────
// ── End of slideshow scroll trigger ───────────────────────────────────────────
